import React, { useEffect, useState } from "react";
import ModalGeneralComponent from "./ModalGeneralComponent";
import PaginadorComponent from "./PaginadorComponent";
import stylebtn from '../styles/btn.module.scss';
import { useFormatter } from "../hooks/useFormatter";
import { useFechaActual } from "../hooks/useFechaActual";
const ModalNotificacionComponent = (props) => {
    const { showNotificacion,
        handleClaseNotificacion,
        abrirNotificaciones,
        currentPageDataNotificaciones,
        cantidadFacurasabiertas,
        setStep,
        step } = props;

    //const [fecha, setFecha] = useState('');
    const [currentPageNoti, setCurrentPageNoti] = useState(0);
    const { formatDate, formatDateUTC } = useFormatter();
    const { fecha } = useFechaActual();
    /*const capturarFecha = () => {
        const hoy = new Date();
        const year = hoy.getFullYear();
        const month = String(hoy.getMonth() + 1).padStart(2, "0");
        const day = String(hoy.getDate()).padStart(2, "0");
        const fechaFormateada = `${year}-${month}-${day}`; // YYYY-MM-DD
        setFecha(fechaFormateada);
    };

    useEffect(() => {
        capturarFecha();
    }, [])*/


    const itemsPerPageNoti = 6;
    const pageCountNoti = Math.ceil(currentPageDataNotificaciones.length / itemsPerPageNoti);
    const data = currentPageDataNotificaciones.slice(
        currentPageNoti * itemsPerPageNoti,
        (currentPageNoti + 1) * itemsPerPageNoti
    );

    const cambioStep = (num) => {
        setStep(num ?? 1);
        console.log('step', num)
    }



    return (
        <ModalGeneralComponent
            ModalHeader
            titulo={`${step === 1 ? 'Actividades pendiente' : 'Facturas  pendiente de pago '} ${currentPageDataNotificaciones?.length}`}
            styleGroup="d-flex align-items-center modal-notificacion "
            styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
            show={showNotificacion}
            handleClose={handleClaseNotificacion}
            handleShow={abrirNotificaciones}
        >

            <div className="table-responsive mt-4">
                <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
                    <button type="button" className={`${stylebtn.btn_menu} ${step === 1 && stylebtn.active}`} onClick={() => cambioStep(1)}>Notas</button>
                    <button type="button" className={`${stylebtn.btn_menu} ${step === 2 && stylebtn.active}`} onClick={() => cambioStep(2)}>Ventas rápidas</button>
                    <button type="button" className={`${stylebtn.btn_menu} ${step === 3 && stylebtn.active}`} onClick={() => cambioStep(3)}>Facturas</button>
                </div>
                {step !== 1 ? <table className="table table-bordered tableGeneral">
                    <thead>
                        <tr>
                            <th scope="col " className="color-madera">
                                #
                            </th>
                            <th scope="col " className="color-madera">
                                N° Factura
                            </th>
                            <th scope="col" className="color-madera">
                                DOCUMENTO
                            </th>
                            <th scope="col" className="color-madera">
                                NOMBRES
                            </th>
                            <th scope="col" className="color-madera">
                                VALOR
                            </th>
                            <th scope="col" className="color-madera">
                                PENDIENTE DE PAGO
                            </th>

                            <th scope="col" className="color-madera">
                                FECHA LIMITE DE PAGO
                            </th>
                            <th scope="col" className="color-madera">
                                FECHA DE FACTURA
                            </th>
                            <th scope="col" className="color-madera">
                                ESTADO
                            </th>
                        </tr>
                    </thead>
                    {data && data?.length !== 0 ? (
                        <tbody>
                            {data.map((item, index) => {
                                let fechaMostrada;

                                if (step === 2) {
                                    fechaMostrada = item?.fecha_creacion
                                        ? formatDateUTC(item?.fecha_creacion)
                                        : formatDate(item?.createdAt);
                                } else {
                                    fechaMostrada = formatDate(item?.formattedDate);
                                }
                              
                                return (
                                    <tr key={index}>
                                        <th>{index + 1}</th>
                                        <th>{item?.numeroFactura}</th>
                                        <td>{step === 2 ? item?.cedula : item?.Cliente?.Persona?.cedula}</td>
                                        <td>
                                            {step === 2 ? item?.nombre : item?.Cliente?.Persona?.nombre} {item?.Cliente?.Persona?.apellido}
                                        </td>
                                        <td>${Number(item?.total).toLocaleString('es-ES')}</td>
                                        <td>${Number(step === 2 ? (item?.total - item?.total_pagado) : (item?.financiado - item?.sumaAbonos)).toLocaleString('es-ES')}</td>
                                        <td>{step === 2 ? formatDateUTC(item?.fecha_vencimiento) : formatDateUTC(item?.formattfechaDePago)}</td>
                                        <td>{fechaMostrada}</td>
                                        <td
                                            className={`${item?.fecha_vencimiento ?? item?.formattfechaDePago < fecha ? 'bg-red color-white' : 'bg-yellow color-white'}`}
                                        >
                                            {item?.fecha_vencimiento ?? item?.formattfechaDePago < fecha ? 'Vencida' : 'Abierta'}
                                        </td>

                                    </tr>
                                );
                            })}

                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                {' '}
                                <td colSpan={12} className="text-center">
                                    SIN FACTURA
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table> :
                    <table className="table table-bordered tableGeneral">
                        <thead>
                            <tr>
                                <th scope="col " className="color-madera">
                                    #
                                </th>
                                <th scope="col " className="color-madera">
                                    Descripción
                                </th>
                                <th scope="col" className="color-madera">
                                    Monto
                                </th>
                                <th scope="col" className="color-madera">
                                    Fecha de Registro
                                </th>
                                <th scope="col" className="color-madera">
                                    Fecha de caducidad
                                </th>
                                <th scope="col" className="color-madera">
                                    Para cuando la actividad ?
                                </th>
                            </tr>
                        </thead>
                        {data && data?.length !== 0 ? (
                            <tbody>
                                {data.map((item, index) => {
                                    const fechaCad = item?.fecha_caducidad;
                                    let estado = "";
                                    let bg = "";
                                    if (fechaCad < fecha) {
                                        estado = "Vencida";
                                        bg = 'bg-red color-white';
                                    } else if (fechaCad === fecha) {
                                        estado = "Para Hoy";
                                        bg = 'bg-yellow color-white';
                                    } else {
                                        estado = "Para Mañana";
                                        bg = 'bg-success color-white';
                                    }
                                    return (
                                        <tr key={index}>
                                            <th>{index + 1}</th>
                                            <th>{item?.descripcion}</th>
                                            <td>${item?.monto == 0 ? '--------' : Number(item?.monto).toLocaleString('es-ES')}</td>
                                            <td>
                                                {formatDate(item?.createdAt)}
                                            </td>
                                            <td>{formatDateUTC(item?.fecha_caducidad)}</td>

                                            <td
                                                className={`${bg}`}
                                            >
                                                {estado}
                                            </td>

                                        </tr>
                                    );
                                })}

                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    {' '}
                                    <td colSpan={12} className="text-center">
                                        SIN NOTIFICCIONES
                                    </td>
                                </tr>
                            </tbody>
                        )}

                    </table>
                }


                {pageCountNoti > 1 && (
                    <PaginadorComponent
                        setCurrentPage={setCurrentPageNoti}
                        pages={pageCountNoti}
                        styleGroup="d-flex justify-content-center pt-4"
                    />
                )}

            </div>

            <div className="d-flex justify-content-end">
                <button type="button" onClick={handleClaseNotificacion} className={`btn ${stylebtn.btn} ${stylebtn.primary} `}>
                    OK
                </button>

            </div>

        </ModalGeneralComponent >
    )
}

export default ModalNotificacionComponent;